import { EmptyPage } from '../empty-page/EmptyPage';

export const Tasks = () => {
  return <EmptyPage />;
};
